export const TENANT_WORKSPACE_DESTINATIONS = Object.freeze([
  { id: 'overview', label: 'Overview', path: '/tenant', permission: 'operations:read' },
  { id: 'locations', label: 'Locations', path: '/tenant/locations', permission: 'locations:read', count: 'locationCount' },
  { id: 'market', label: 'Market', path: '/tenant/market', permission: 'marketplace_intelligence:read' },
  { id: 'money', label: 'Money', path: '/tenant/money', permission: 'money:read' },
  { id: 'activity', label: 'Activity', path: '/tenant/activity', permission: 'locations:read' },
]);

export const TENANT_BUSINESS_PROFILE_DESTINATION = Object.freeze({
  id: 'business-profile',
  label: 'Business profile',
  path: '/tenant/business-profile',
  permission: 'account_settings:read',
});

const DESTINATION_BY_PATH = new Map([
  ...TENANT_WORKSPACE_DESTINATIONS,
  TENANT_BUSINESS_PROFILE_DESTINATION,
].map((destination) => [destination.path, destination]));

export const tenantDestinationForPath = (pathname = '/tenant') => (
  DESTINATION_BY_PATH.get(pathname.replace(/\/$/, '') || '/tenant') || null
);

export const tenantLegacyAccountDestination = (search = '') => (
  new URLSearchParams(search).has('stripe')
    ? `/tenant/money${search}`
    : `/tenant/business-profile${search}`
);

export const tenantSupportDestination = (pathname = '/tenant', search = '') => {
  const returnTo = `${pathname}${search}`;
  return `/contact?from=tenant&returnTo=${encodeURIComponent(returnTo)}`;
};

export const tenantReturnDestination = (search = '') => {
  const returnTo = new URLSearchParams(search).get('returnTo') || '';
  if (returnTo === '/tenant' || returnTo.startsWith('/tenant/')) return returnTo;
  return '/tenant';
};

export const canAccessTenantDestination = (destination, permissions = []) => (
  Boolean(destination && permissions.includes(destination.permission))
);
